/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Step_Manage_DescInputs */

const en_directory_submit_step_manage_desc = /** @type {(inputs: Directory_Submit_Step_Manage_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status and listing updates`)
};

const zh_directory_submit_step_manage_desc = /** @type {(inputs: Directory_Submit_Step_Manage_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`状态与资料更新`)
};

/**
* | output |
* | --- |
* | "Status and listing updates" |
*
* @param {Directory_Submit_Step_Manage_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_step_manage_desc = /** @type {((inputs?: Directory_Submit_Step_Manage_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Step_Manage_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_step_manage_desc(inputs)
	return zh_directory_submit_step_manage_desc(inputs)
});
export { directory_submit_step_manage_desc as "directory.submit.step_manage_desc" }